import { IconManifest } from 'app/agriculture/icons/types';
import { MapIconOptions } from './types';
import { BillboardIcon } from './BillboardIcon';
import { BillboardCircle } from './BillboardCircle';
import { BillboardPin } from './BillboardPin';
import { BillboardBubbleText } from './BillboardBubbleText';
import { BillboardPercentageBar } from './BillboardPercentageBar';
import { BillboardSmallCircle } from 'app/agriculture/icons/utils/map-icon-utils/BillboardSmallCircle';
import { BillboardStatusCircle } from 'app/agriculture/icons/utils/map-icon-utils/BillboardStatusCircle';

interface BillboardProps extends MapIconOptions {
    icon?: IconManifest;
}

export function Billboard({
    icon,
    billboardType = 'circle',
    shouldIncludeBorder = false,
    color = '#00f',
    borderColor = '#fff',
    iconColor = '#fff',
    bubbleText,
    shouldIncludeStatus = false,
    statusColor,
    percentage,
}: BillboardProps) {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 384 384">
            ${bubbleText == null ? '' : BillboardBubbleText({ bubbleText })}
            ${
                billboardType === 'pin'
                    ? BillboardPin({ color, shouldIncludeBorder, borderColor })
                    : ''
            }
            ${
                billboardType === 'circle'
                    ? BillboardCircle({ color, shouldIncludeBorder, borderColor })
                    : ''
            }
            ${
                billboardType === 'smallCircle'
                    ? BillboardSmallCircle({ color, shouldIncludeBorder, borderColor })
                    : ''
            }
            ${BillboardIcon({ icon, x: 128, y: billboardType === 'pin' ? 192 : 128, iconColor })}
            ${
                !shouldIncludeStatus
                    ? ''
                    : BillboardStatusCircle({ color: statusColor, borderColor })
            }
            ${percentage == null ? '' : BillboardPercentageBar({ percentage })}
        </svg>
    `;
}
